// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicePriorities_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/service_priorities/salvar
 *
 * Create or update a service-priority pricing row.
 */
import { registerContract } from './validate'

export interface ServicePriorities_SalvarInput {
so_service_priority_service_id: number
so_service_priority_priority_id: number
so_service_priority_price: number
so_service_priority_deadline_days: number
so_service_priority_id?: number
so_service_priority_franchise_id?: number
so_service_priority_order?: number
}

registerContract('ServicePriorities_SalvarInput', {
  so_service_priority_service_id:    { type: 'number',  required: true },
  so_service_priority_priority_id:   { type: 'number',  required: true },
  so_service_priority_price:         { type: 'number',  required: true },
  so_service_priority_deadline_days: { type: 'number',  required: true },
  so_service_priority_id:            { type: 'number',  required: false },
  so_service_priority_franchise_id:  { type: 'number',  required: false },
  so_service_priority_order:         { type: 'number',  required: false },
})
